import { render, staticRenderFns } from "./CisNations.vue?vue&type=template&id=055dc9ac&scoped=true&"
import script from "./CisNations.vue?vue&type=script&lang=js&"
export * from "./CisNations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055dc9ac",
  null
  
)

export default component.exports